(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroDeleteController',RubroDeleteController);

    RubroDeleteController.$inject = ['$uibModalInstance', 'entity', 'Rubro'];

    function RubroDeleteController($uibModalInstance, entity, Rubro) {
        var vm = this;

        vm.rubro = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Rubro.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
